import React from 'react'
import { Menu, Icon, Popover, MenuItem, Position } from "@blueprintjs/core";
import { Translate, I18n } from "react-redux-i18n";

const CircleAdminTabs=({collections, selected, onTabClick})=>{
    const collections_in_tabs =
      collections.length > 3
      ? collections.slice(0, 3)
      : collections.slice(0, collections.length);

    const collections_in_popover = collections.length > 3 ? collections.slice(3, collections.length) : [];
    const show_popover = collections_in_popover.length>0;
    const tabExtenderMenu = (
        <Menu>
          {collections_in_popover.map((collection, idx) => (
            <MenuItem
              onClick={_ => onTabClick(collection.key)}
              key={idx}
              icon={collection.icon}
              text={I18n.t(`admin_tabs.${collection.name}`)}
              disabled={collection.disabled?collection.disabled:false}
            />
          ))}
        </Menu>
    );
  return (
    <section className="tab-section">
      <div className="tabs circle-admin">
        {collections_in_tabs.map((collection, idx) => {
          let selectedClass = collection.key === selected ? "selected" : "";
          selectedClass = collection.disabled?"disabled":selectedClass;
          return (
            <div
              onClick={_ =>{if(collection.disabled){return};onTabClick(collection.key)}}               
              key={idx}
              className={`tab ${selectedClass}`}
            >
              <Icon icon={collection.icon} className="icon" iconSize="20" />
              <strong>
                <Translate value={`admin_tabs.${collection.name}`} />
              </strong>
            </div>
          );
        })}
        {show_popover && 
          <Popover content={tabExtenderMenu} position={Position.BOTTOM} className='tab-extender'>
            <div className="tab extender">
              <Icon icon="more" iconSize="20" />
            </div>
          </Popover>
        }
      </div>
  </section>
  )
}
export default CircleAdminTabs;